<template>
  <span class="file-upload-button">
    <input
      :accept="acceptedExtnames"
      :disabled="disabled"
      :multiple="multiple"
      @change="onSelect"
      class="file-upload-button__input"
      ref="fileInput"
      type="file"
    />
    <common-button
      :disabled="disabledOrUploading"
      :size="size"
      :text="text"
      :type="type"
      @click="$refs.fileInput.click()"
      icon="cloud-upload"
    >
      <slot>
        <span v-if="text">{{text}}</span>
        <span v-else>{{$t('actions.upload')}}</span>
      </slot>
    </common-button>
  </span>
</template>

<script>
import CommonButton from '@/components/CommonButton';
import Toast from '@/helpers/Toast';
import uploadAttachmentsMutation
  from '@/api/mutations/upload-attachments.graphql';

const TYPES = {
  IMAGE: ['.jpeg', '.jpe', '.jpg', '.gif', '.png', '.svg'],
  VIDEO: ['.mp4', '.webm'],
  DOCUMENT: ['.pdf', '.rtf'],
};

TYPES.MEDIA_OBJECT = TYPES.IMAGE.concat(TYPES.VIDEO);

export default {
  name: 'file-upload-button',
  components: {
    CommonButton,
  },
  props: {
    text: String,
    attachmentType: String,
    type: {
      type: String,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: String,
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasError: false,
      isUploading: false,
    };
  },
  computed: {
    acceptedExtnames() {
      let extnames = TYPES[this.attachmentType];
      if (!extnames) {
        extnames = [];
        Object.keys(TYPES).forEach((type) => {
          if (type !== 'MEDIA_OBJECT') {
            TYPES[type].forEach(extname => extnames.push(extname));
          }
        });
      }
      return extnames.join(',');
    },
    disabledOrUploading() {
      return this.disabled || this.isUploading;
    },
    buttonType() {
      if (this.hasError) return 'danger';
      return this.type;
    },
  },
  methods: {
    click() {
      this.$refs.fileInput.click();
    },
    focus() {
      this.click();
    },
    onSelect(event) {
      this.hasError = false;
      return this.upload(event.target.files);
    },
    async upload(files) {
      const attachments = [...files].map(file => ({ file }));
      if (!attachments.length) return;

      this.isUploading = true;
      const operation = await this.$apollo.mutate({
        mutation: uploadAttachmentsMutation,
        variables: { attachments },
      });
      this.isUploading = false;
      const uploads = [];
      let errors = [];
      operation.data.uploadAttachments.forEach((op) => {
        if (op.errors.length) {
          errors = errors.concat(op.errors);
        } else {
          uploads.push(op.attachment);
        }
      });
      if (uploads.length || errors.length) {
        if (errors.length) {
          this.hasError = true;
          Toast.error(this.$t('errorPattern', { message: errors[0].message }));
        }
        this.$emit('upload', { attachments: uploads, errors });
        this.$emit('change', uploads);
        this.$emit('input', uploads);
      }
      this.reset();
    },
    reset() {
      this.$refs.fileInput.value = '';
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          upload: 'Hochladen',
        },
        errorPattern: 'Datei {message}',
      },
    },
  },
};
</script>

<style scoped lang="scss">
.file-upload-button__input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// FileUploadButton.vue?0ec8281f